import React from "react";
import img from "../../assets/team/team1.png";
function Linda() {
  return (
    <div className="bg-[#E8FCFF] w-full flex justify-center items-center py-11">
      <div className="max-w-[1440px] flex justify-between flex-col lg:flex-row items-center px-10 w-full gap-10">
        <div className="flex justify-center flex-col items-start gap-4">
          <h1 className="font-bold text-lightGreen-500 text-3xl md:text-5xl">
            Dr. Linda Heitzmann-Powell
          </h1>
          <h2 className="font-bold text-lightGreen-500 text-xl md:text-2xl">
            PhD., BCBA-D
          </h2>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            Dr. Heitzmann-Powell is one of the most prominent figures in Autism Research & Training.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            For the last <span className="font-mono">20</span> years, her
            research and academic interests have focused on parent training,
            evidence based autism treatment and the use of technology to
            increase access for families of children with autism spectrum
            disorder.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            In <span className="font-mono">2003</span>, Dr. Heitzmann-Powell
            received her Ph.D. in Developmental and Child Psychology from the
            University of Kansas. Dr. Heitzman-Powell is an active member of the
            ASD community. She has testified before the Kansas Legislature,
            advocating for evidence-based practices for individuals with ASD.
          </p>
          <p className="font-normal text-justify text-lightGreen-500 text-lg lg:max-w-[680px]">
            She is also a BCBA at the doctoral level and is a member of the
            International Behavior Analyst Organization.
          </p>
        </div>
        <img src={img} alt="" />
      </div>
    </div>
  );
}

export default Linda;
